import { usePlanContext } from '@/store/contexts/PlanContext'

/**
 * Plan 관련 Custom Hook
 * PlanContext를 래핑하여 사용하기 편리하게 만듦
 */
export function usePlan() {
  return usePlanContext()
}

